<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">

					<el-table-column type="selection"> </el-table-column>
					<el-table-column prop="DepartmentName" label="部门" :formatter="formatDepartmentNameCol" width></el-table-column>
					<el-table-column prop="Title" label="作业标题" width=""></el-table-column>
					<el-table-column prop="HworkType" label="作业类型" width=""></el-table-column>
					<el-table-column prop="TeacherName" label="教师" width=""></el-table-column>
					<el-table-column prop="CourseName" label="课程名称" width=""></el-table-column>
					<el-table-column prop="AssignTime" label="布置时间" width=""></el-table-column>
					<el-table-column prop="DurationMinutes" label="作业时长（分钟）" width="170px"></el-table-column>
					<el-table-column prop="Deadline" label="截止时间" width=""></el-table-column>
					<el-table-column prop="Remark" label="备注" width=""></el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="110px" :rules="editFormRules" ref="editForm">

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"
							@change="handleChange"></el-cascader>
					</el-form-item>

					<el-form-item label="教师人员" prop="TeacherId">
						<el-select v-model="editForm.TeacherId" placeholder="请选择" style="width: 200px">
							<el-option v-for="item in teacherMasterList" :key="item.Id" :label="item.TeacherName"
								:value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="课程ID" prop="CourseId">
						<el-select v-model="editForm.CourseId" placeholder="未指定" style="width: 200px;">
							<el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="作业标题" prop="Title">
						<el-input v-model="editForm.Title" maxlength="100" placeholder="请输入作业标题"></el-input>
					</el-form-item>

					<!-- 新增作业类型选择 -->
					<el-form-item label="作业类型" prop="HworkType">
						<el-select v-model="editForm.HworkType" placeholder="请选择作业类型" style="width: 200px;">
							<el-option label="口头作业" value="口头作业"></el-option>
							<el-option label="书面作业" value="书面作业"></el-option>
							<el-option label="实践作业" value="实践作业"></el-option>
							<el-option label="体育锻炼" value="体育锻炼"></el-option>
							<el-option label="其他" value="其他"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="作业内容" prop="Content">
						<el-input type="textarea" v-model="editForm.Content" maxlength="2000"
							placeholder="请输入作业内容"></el-input>
					</el-form-item>

					<el-form-item label="布置时间" prop="AssignTime">
						<el-date-picker v-model="editForm.AssignTime" type="datetime"
							placeholder="选择布置时间"></el-date-picker>
					</el-form-item>

					<el-form-item label="作业时长（分钟）" prop="DurationMinutes">
						<el-input-number v-model="editForm.DurationMinutes" :min="1" :step="1" :precision="0"
							placeholder="请输入作业时长（分钟）" />
					</el-form-item>

					<el-form-item label="截止时间" prop="Deadline">
						<el-date-picker v-model="editForm.Deadline" type="datetime"
							placeholder="选择截止时间"></el-date-picker>
					</el-form-item>
					<el-form-item label="备注" prop="Remarks">
						<el-input v-model="editForm.Remarks" maxlength="500" placeholder="请输入备注"></el-input>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"
							@change="handleChange"></el-cascader>
					</el-form-item>

					<el-form-item label="教师人员" prop="TeacherId">
						<el-select v-model="addForm.TeacherId" placeholder="请选择" style="width: 200px;">
							<el-option v-for="item in teacherMasterList" :key="item.Id" :label="item.TeacherName"
								:value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="课程ID" prop="CourseId">
						<el-select v-model="addForm.CourseId" placeholder="请选择" style="width: 200px;">
							<el-option v-for="item in courseList" :key="item.Id" :label="item.CourseName"
								:value="item.Id"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="作业标题" prop="Title">
						<el-input v-model="addForm.Title" maxlength="100" placeholder="请输入作业标题"></el-input>
					</el-form-item>

					<!-- 新增作业类型选择 -->
					<el-form-item label="作业类型" prop="HworkType">
						<el-select v-model="addForm.HworkType" placeholder="请选择作业类型" style="width: 200px;">
							<el-option label="口头作业" value="口头作业"></el-option>
							<el-option label="书面作业" value="书面作业"></el-option>
							<el-option label="实践作业" value="实践作业"></el-option>
							<el-option label="体育锻炼" value="体育锻炼"></el-option>
							<el-option label="其他" value="其他"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="作业内容" prop="Content">
						<el-input type="textarea" v-model="addForm.Content" maxlength="2000"
							placeholder="请输入作业内容"></el-input>
					</el-form-item>
					<el-form-item label="布置时间" prop="AssignTime">
						<el-date-picker v-model="addForm.AssignTime" type="datetime"
							placeholder="选择布置时间"></el-date-picker>
					</el-form-item>

					<el-form-item label="作业时长（分钟）" prop="DurationMinutes">
						<el-input-number v-model="addForm.DurationMinutes" :min="1" :step="1" :precision="0"
							placeholder="请输入作业时长（分钟）" />
					</el-form-item>

					<el-form-item label="截止时间" prop="Deadline">
						<el-date-picker v-model="addForm.Deadline" type="datetime"
							placeholder="选择截止时间"></el-date-picker>
					</el-form-item>
					<el-form-item label="备注" prop="Remarks">
						<el-input v-model="addForm.Remarks" maxlength="500" placeholder="请输入备注"></el-input>
					</el-form-item>

				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" class="quill-upload" :data="$ossUploadData('ClassHomework')" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>
		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getHomeworkList, editHomework, addHomework, deleteHomework } from '../../api/modules/misc';
import deptCascaderSelectionMixin from '../../mixins/deptCascaderSelectionMixin'
import { BaseApiUrl } from '../../api/base';
import { GetSysCourseByDepartmentId } from '../../api/modules/schedule-course';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	mixins: [deptCascaderSelectionMixin],
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			courseList: [], // 课程下拉数据
			teacherMasterList: [],// 教师下拉数据
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			imageUrl: '',
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],

				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
				CourseId: [
					{ required: true, message: '请选择科目', trigger: 'change' }
				],
				TeacherId: [
					{ required: true, message: '请选择教师', trigger: 'change' }
				],
				Content: [
					{ required: true, message: '请输入内容', trigger: 'blur' }
				],
				HworkType: [{ required: true, message: '请选择作业类型', trigger: 'change' }], // 新增作业类型验证
				AssignTime: [
					{ required: true, message: '请选择布置时间', trigger: 'change' }
				],
				Deadline: [
					{ required: true, message: '请选择截止时间', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Title: '',
				CourseId: '',
				Content: '',
				Attachments: '',
				TeacherId: '',
				ClassId: 0,
				AssignTime: '',
				Duration: 7,
				Deadline: '',
				Remarks: '',
				ReviewedPersons: [],
				Dids: [],
				DepartmentId: 0,
				DurationMinutes: 0, // 作业时长（分钟）
				HworkType: '', // 新增作业类型字段
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
				CourseId: [
					{ required: true, message: '请选择科目', trigger: 'change' }
				],
				TeacherId: [
					{ required: true, message: '请选择教师', trigger: 'change' }
				],
				Content: [
					{ required: true, message: '请输入内容', trigger: 'blur' }
				],
				HworkType: [{ required: true, message: '请选择作业类型', trigger: 'change' }], // 新增作业类型验证
				AssignTime: [
					{ required: true, message: '请选择布置时间', trigger: 'change' }
				],
				Deadline: [
					{ required: true, message: '请选择截止时间', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				Title: '',
				CourseId: '',
				Content: '',
				Attachments: '',
				TeacherId: '',
				ClassId: 0,
				AssignTime: '',
				Duration: 7,
				Deadline: '',
				Remarks: '',
				Dids: [],
				DepartmentId: 0,
				DurationMinutes: 0, // 作业时长（分钟）
				HworkType: '', // 新增作业类型字段
			},
			DepartmentId: 0,
			SchoolId: 0, // 新增：学校ID
			multipleSelection: [],
			currentDepartmentName: ''
		}
	},
	methods: {
		/** 获取教师下拉使用的顶部学校 ID，保留 long 字符串精度。 */
		resolveTeacherSchoolId() {
			const candidates = [
				this.$store.state.activeSchoolId,
				window.localStorage.getItem('activeSchoolId'),
				this.SchoolId,
			]
			return candidates.find(id => /^\d+$/.test(String(id || '')) && String(id) !== '0') || ''
		},

		handleChange(value) {

			this.addForm.CourseId = "";
			this.editForm.CourseId = "";

			this.addForm.TeacherId = '';
			this.editForm.TeacherId = '';

			var id = "";

			if (value.length > 1) {
				id = value[value.length - 1];
			} else {
				id = value[0];
			}

			let para = {
				departmentId: id,
			};
			GetSysCourseByDepartmentId(para).then(res => {
				this.courseList = res.data.response || [];
			});

			if (!this.resolveTeacherSchoolId()) {
				this.teacherMasterList = []
				this.$message.warning('请先选择学校')
				return
			}
			getTeacherMasterList({ departmentId: id }).then((res) => {
				this.teacherMasterList = res.data.response;
			});
		},

		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.captureDepartmentTreeContext(data, node)
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
			}
			getHomeworkList(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getHomeworkList(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', this.sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			this.imageUrl = this.editForm.imageUrl

			this.options = []
			this.initDeptFormSelection('edit', row[0].DepartmentId, row[0].Dids).then((path) => {
				this.applyDeptCascaderPath(this.editForm, path)
			}).catch(() => {})

			let depIdpara = {
				departmentId: row[0].DepartmentId,
			};
			GetSysCourseByDepartmentId(depIdpara).then(res => {
				this.courseList = res.data.response || [];
			});

			if (this.resolveTeacherSchoolId()) {
				getTeacherMasterList({ departmentId: row[0].DepartmentId }).then((res) => {
					this.teacherMasterList = res.data.response;
				});
			} else {
				this.teacherMasterList = []
			}
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			if (!this.getSchoolIdForDeptCascader()) {
				this.$message.warning("请先在顶部切换学校！");
				return;
			}
			this.addForm = {
				Title: '',
				CourseId: '',
				Content: '',
				Attachments: '',
				TeacherId: '',
				ClassId: 0,
				AssignTime: '',
				Duration: 7,
				Deadline: '',
				Remarks: '',
				Dids: [],
				DepartmentId: 0,
				DurationMinutes: 0, // 作业时长（分钟）
				HworkType: '', // 新增作业类型字段
			}
			this.imageUrl = ''
			this.options = []
			this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
				this.addFormVisible = true
				this.applyDeptCascaderPath(this.addForm, path)
				if (path.length) {
					this.$nextTick(() => this.handleChange(path))
				}
			}).catch(() => {})
		},
		handleAvatarSuccess(res, file) {
			this.imageLoadding = false
			console.log(res)
			this.imageUrl = res.response
		},

		quillSuccess(response) {
			if (response.success) {
				// 获取文本编辑器
				const quill = this.$refs.myQuillEditor.quill
				// 获取光标位置
				const pos = quill.getSelection().index
				// 插入图片到光标位置
				quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
			} else {
				this.$message({
					message: response.msg,
					type: 'error',
				})
			}
		},
		beforeAvatarUpload(file) {
			// 这里可以过滤不要的文件
			this.imageLoadding = true
			return true
		},
		//编辑
		editSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.editLoading = true
						//NProgress.start();
						this.editForm.imageUrl = this.imageUrl
						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editHomework(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.addLoading = true
						//NProgress.start();
						this.addForm.imageUrl = this.imageUrl
						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addHomework(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})
				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteHomework(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		// 格式化部门名称：只保留路径的最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}
</style>